import { onSessionLost } from '@Domain/Api';

export default (listener: () => void): (() => void) => onSessionLost(listener);
